/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSessionRequest,
  SessionListResponse,
  SessionResponse,
  SessionValidationResponse,
  SwitchTenantRequest,
  TenantSwitchResponse,
  UpdateActivityRequest,
  UpdateTenantSelectionRequest,
} from '../models/index';
import {
    CreateSessionRequestFromJSON,
    CreateSessionRequestToJSON,
    SessionListResponseFromJSON,
    SessionListResponseToJSON,
    SessionResponseFromJSON,
    SessionResponseToJSON,
    SessionValidationResponseFromJSON,
    SessionValidationResponseToJSON,
    SwitchTenantRequestFromJSON,
    SwitchTenantRequestToJSON,
    TenantSwitchResponseFromJSON,
    TenantSwitchResponseToJSON,
    UpdateActivityRequestFromJSON,
    UpdateActivityRequestToJSON,
    UpdateTenantSelectionRequestFromJSON,
    UpdateTenantSelectionRequestToJSON,
} from '../models/index';

export interface ClearSelectedTenantsRequest {
    sessionId: string;
}

export interface CreateSessionOperationRequest {
    authorization?: string;
    createSessionRequest?: CreateSessionRequest;
}

export interface DestroySessionRequest {
    sessionId: string;
    reason?: string;
    deletedByUserId?: string;
}

export interface DiagnosePermissionsRequest {
    sessionId: string;
    userId: string;
    tenantId: string;
}

export interface ExtendSessionRequest {
    sessionId: string;
    requestBody: { [key: string]: number; };
}

export interface GetActiveSessionsRequest {
    sessionId?: string;
    tenantIds?: string;
}

export interface GetAllSessionsRequest {
    status?: string;
    sessionId?: string;
    tenantIds?: string;
}

export interface GetAvailableTenants1Request {
    sessionId: string;
}

export interface GetAvailableTimezonesRequest {
    sessionId: string;
}

export interface GetConcurrentSessionLimitRequest {
    sessionId?: string;
}

export interface GetCurrentTenantRequest {
    sessionId: string;
}

export interface GetSelectedTenantsRequest {
    sessionId: string;
}

export interface GetSessionRequest {
    sessionId: string;
}

export interface GetSessionStatsRequest {
    sessionId?: string;
}

export interface GetSessionTimeoutRequest {
    sessionId?: string;
}

export interface GetSessionsByTenantRequest {
    tenantId: string;
    sessionId?: string;
}

export interface GetUserSessionsRequest {
    userId: string;
    sessionId?: string;
}

export interface GetUserTimezone1Request {
    sessionId: string;
}

export interface HasAccessToTenantRequest {
    sessionId: string;
    tenantId: string;
}

export interface LogActivityRequest {
    sessionId: string;
    requestBody: { [key: string]: any; };
}

export interface SelectTenantsRequest {
    sessionId: string;
    updateTenantSelectionRequest: UpdateTenantSelectionRequest;
}

export interface SetConcurrentSessionLimitRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface SetSessionTimeoutRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface SetUserTimezoneRequest {
    sessionId: string;
    requestBody: { [key: string]: string; };
}

export interface SwitchTenantOperationRequest {
    sessionId: string;
    switchTenantRequest: SwitchTenantRequest;
}

export interface UpdateActivityOperationRequest {
    updateActivityRequest: UpdateActivityRequest;
}

export interface ValidateSessionRequest {
    sessionId: string;
}

/**
 * SessionsApi - interface
 * 
 * @export
 * @interface SessionsApiInterface
 */
export interface SessionsApiInterface {
    /**
     * Removes expired sessions from the system (admin only)
     * @summary Cleanup expired sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    cleanupExpiredSessionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Removes expired sessions from the system (admin only)
     * Cleanup expired sessions
     */
    cleanupExpiredSessions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Clears the selected tenants for multi-tenant aggregation, defaulting to current tenant only.  ## Effect - Removes all selected tenants from the session - Defaults to showing only current tenant data - All subsequent API calls will respect current tenant only - Cross-tenant aggregation is disabled  ## Use Cases - **Reset to Default**: Return to single-tenant view - **Security Cleanup**: Clear multi-tenant access after sensitive operations - **Session Reset**: Reset tenant selection to safe defaults - **Access Control**: Ensure only current tenant data is visible  ## Security Benefits - Reduces data exposure to minimum required scope - Prevents accidental cross-tenant data access - Simplifies audit trail to single tenant - Reduces complexity of permission evaluation  ## Implementation This endpoint delegates to the `select-tenants` endpoint with an empty list. 
     * @summary Clear selected tenants
     * @param {string} sessionId Unique session identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    clearSelectedTenantsRaw(requestParameters: ClearSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Clears the selected tenants for multi-tenant aggregation, defaulting to current tenant only.  ## Effect - Removes all selected tenants from the session - Defaults to showing only current tenant data - All subsequent API calls will respect current tenant only - Cross-tenant aggregation is disabled  ## Use Cases - **Reset to Default**: Return to single-tenant view - **Security Cleanup**: Clear multi-tenant access after sensitive operations - **Session Reset**: Reset tenant selection to safe defaults - **Access Control**: Ensure only current tenant data is visible  ## Security Benefits - Reduces data exposure to minimum required scope - Prevents accidental cross-tenant data access - Simplifies audit trail to single tenant - Reduces complexity of permission evaluation  ## Implementation This endpoint delegates to the `select-tenants` endpoint with an empty list. 
     * Clear selected tenants
     */
    clearSelectedTenants(requestParameters: ClearSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates a new user session with JWT token validation and comprehensive multi-tenant access control.  ## Authentication Flow 1. Validates JWT token from Authorization header 2. Extracts user information from JWT claims 3. Determines user\'s tenant access based on domain mapping 4. Creates or retrieves user record in the system 5. Establishes session with current tenant context 6. Loads comprehensive permissions for current and cross-tenant access  ## Multi-Tenant Context - Users can belong to multiple tenants simultaneously - Session establishes a \'current tenant\' for API operations - Cross-tenant relationships enable access to other tenants - Selected tenants allow aggregation across multiple tenant datasets  ## Permission System - RBAC (Role-Based Access Control) with granular permissions - MAC (Mandatory Access Control) with security labels - Cross-tenant permissions for relationship-based access - Effective permissions combine all access levels  ## Session Lifecycle - Sessions are created with configurable timeout - Activity tracking extends session duration - Sessions can be switched between available tenants - Expired sessions are automatically cleaned up  ## Session Transport - Browser: HttpOnly cookie `aegis_session_id` is set on success (SameSite=Lax, Secure) - Integrations: prefer header `X-Session-Id: <sessionId>` - Legacy fallback: `sessionId` query parameter 
     * @summary Create a new session
     * @param {string} [authorization] Authorization header containing the JWT token. Format: \&quot;Bearer &lt;jwt_token&gt;\&quot;  ## Token Processing 1. Token is extracted from \&quot;Bearer \&quot; prefix 2. Token is validated for signature and expiration 3. Claims are extracted for user identification 4. Domain is extracted from email for tenant mapping 5. User is created or retrieved based on JWT claims  ## Security Considerations - Token must be from trusted identity provider - Token expiration is strictly enforced - Failed authentication attempts are audited - Rate limiting applies to authentication attempts 
     * @param {CreateSessionRequest} [createSessionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    createSessionRaw(requestParameters: CreateSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>>;

    /**
     * Creates a new user session with JWT token validation and comprehensive multi-tenant access control.  ## Authentication Flow 1. Validates JWT token from Authorization header 2. Extracts user information from JWT claims 3. Determines user\'s tenant access based on domain mapping 4. Creates or retrieves user record in the system 5. Establishes session with current tenant context 6. Loads comprehensive permissions for current and cross-tenant access  ## Multi-Tenant Context - Users can belong to multiple tenants simultaneously - Session establishes a \'current tenant\' for API operations - Cross-tenant relationships enable access to other tenants - Selected tenants allow aggregation across multiple tenant datasets  ## Permission System - RBAC (Role-Based Access Control) with granular permissions - MAC (Mandatory Access Control) with security labels - Cross-tenant permissions for relationship-based access - Effective permissions combine all access levels  ## Session Lifecycle - Sessions are created with configurable timeout - Activity tracking extends session duration - Sessions can be switched between available tenants - Expired sessions are automatically cleaned up  ## Session Transport - Browser: HttpOnly cookie `aegis_session_id` is set on success (SameSite=Lax, Secure) - Integrations: prefer header `X-Session-Id: <sessionId>` - Legacy fallback: `sessionId` query parameter 
     * Create a new session
     */
    createSession(requestParameters: CreateSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse>;

    /**
     * Terminates a user session
     * @summary Destroy session
     * @param {string} sessionId Session ID to destroy
     * @param {string} [reason] Reason for deletion
     * @param {string} [deletedByUserId] User ID who deleted the session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    destroySessionRaw(requestParameters: DestroySessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Terminates a user session
     * Destroy session
     */
    destroySession(requestParameters: DestroySessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Diagnoses user permission state for debugging and troubleshooting purposes.  ## Diagnostic Information - **User Details**: User ID, email, and profile information - **Tenant Access**: All tenants the user can access - **Role Assignments**: All roles assigned to the user - **Permission Breakdown**: Detailed permission analysis - **Cross-Tenant Relationships**: Active cross-tenant access - **Effective Permissions**: Final computed permissions  ## Use Cases - **Troubleshooting**: Debug permission-related issues - **Access Verification**: Verify user access to specific resources - **Role Analysis**: Understand role assignments and inheritance - **Cross-Tenant Debugging**: Diagnose cross-tenant access issues - **Security Auditing**: Review user permission state  ## Security Considerations - Only available to users with diagnostic permissions - Sensitive information is included in the response - Should be used only for legitimate debugging purposes - All diagnostic access is audited 
     * @summary Diagnose user permissions
     * @param {string} sessionId Unique session identifier
     * @param {string} userId User ID or email address to diagnose
     * @param {string} tenantId Tenant ID to check permissions for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    diagnosePermissionsRaw(requestParameters: DiagnosePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Diagnoses user permission state for debugging and troubleshooting purposes.  ## Diagnostic Information - **User Details**: User ID, email, and profile information - **Tenant Access**: All tenants the user can access - **Role Assignments**: All roles assigned to the user - **Permission Breakdown**: Detailed permission analysis - **Cross-Tenant Relationships**: Active cross-tenant access - **Effective Permissions**: Final computed permissions  ## Use Cases - **Troubleshooting**: Debug permission-related issues - **Access Verification**: Verify user access to specific resources - **Role Analysis**: Understand role assignments and inheritance - **Cross-Tenant Debugging**: Diagnose cross-tenant access issues - **Security Auditing**: Review user permission state  ## Security Considerations - Only available to users with diagnostic permissions - Sensitive information is included in the response - Should be used only for legitimate debugging purposes - All diagnostic access is audited 
     * Diagnose user permissions
     */
    diagnosePermissions(requestParameters: DiagnosePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Extends session timeout by specified duration
     * @summary Extend session
     * @param {string} sessionId Session ID
     * @param {{ [key: string]: number; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    extendSessionRaw(requestParameters: ExtendSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>>;

    /**
     * Extends session timeout by specified duration
     * Extend session
     */
    extendSession(requestParameters: ExtendSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse>;

    /**
     * Retrieves all active sessions (admin only)
     * @summary Get active sessions
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [tenantIds] Tenant IDs to filter by (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getActiveSessionsRaw(requestParameters: GetActiveSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>>;

    /**
     * Retrieves all active sessions (admin only)
     * Get active sessions
     */
    getActiveSessions(requestParameters: GetActiveSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse>;

    /**
     * Retrieves all sessions with pagination and status filtering (admin only). Status filter options: \'active\' (not expired, not terminated, expiresAt > now), \'expiring_soon\' (expiring within 24 hours), \'expired\' (expiresAt < now OR deletedAt IS NOT NULL), or null/omitted (all sessions)
     * @summary Get all sessions
     * @param {string} [status] Status filter: \&#39;active\&#39;, \&#39;expiring_soon\&#39;, \&#39;expired\&#39;, or null/omitted for all
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [tenantIds] Tenant IDs to filter by (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getAllSessionsRaw(requestParameters: GetAllSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>>;

    /**
     * Retrieves all sessions with pagination and status filtering (admin only). Status filter options: \'active\' (not expired, not terminated, expiresAt > now), \'expiring_soon\' (expiring within 24 hours), \'expired\' (expiresAt < now OR deletedAt IS NOT NULL), or null/omitted (all sessions)
     * Get all sessions
     */
    getAllSessions(requestParameters: GetAllSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse>;

    /**
     * Retrieves list of tenants accessible to the user
     * @summary Get available tenants
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getAvailableTenants1Raw(requestParameters: GetAvailableTenants1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves list of tenants accessible to the user
     * Get available tenants
     */
    getAvailableTenants1(requestParameters: GetAvailableTenants1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves a comprehensive list of available timezone IDs that can be used throughout the application.  ## Timezone Usage - These timezone IDs are used for user preference settings - All timestamps in API responses are in UTC - User\'s preferred timezone is used for display purposes - Timezone validation ensures only valid IANA timezone IDs are accepted  ## Supported Regions - **Americas**: US/Canada timezones, Alaska, Hawaii - **Europe**: Major European cities and regions - **Asia**: Major Asian cities and regions - **Africa**: Major African cities - **Australia/Pacific**: Australian cities and Pacific islands  ## Response Format Returns a simple list of timezone IDs that can be used with other timezone-related endpoints. 
     * @summary Get available timezones
     * @param {string} sessionId Session ID for authentication. Used to validate user session.  ## Session Validation - Session must be active and not expired - No specific permission required (returns reference data only)  ## Note This endpoint returns a static list of available timezones for the application. It is used in Account Settings and only requires valid session authentication. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getAvailableTimezonesRaw(requestParameters: GetAvailableTimezonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Retrieves a comprehensive list of available timezone IDs that can be used throughout the application.  ## Timezone Usage - These timezone IDs are used for user preference settings - All timestamps in API responses are in UTC - User\'s preferred timezone is used for display purposes - Timezone validation ensures only valid IANA timezone IDs are accepted  ## Supported Regions - **Americas**: US/Canada timezones, Alaska, Hawaii - **Europe**: Major European cities and regions - **Asia**: Major Asian cities and regions - **Africa**: Major African cities - **Australia/Pacific**: Australian cities and Pacific islands  ## Response Format Returns a simple list of timezone IDs that can be used with other timezone-related endpoints. 
     * Get available timezones
     */
    getAvailableTimezones(requestParameters: GetAvailableTimezonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Retrieves the current concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Default limit is 20 concurrent sessions per user  ## Security Benefits - Prevents session hijacking through multiple login attempts - Reduces server resource consumption - Limits potential attack surface - Enforces session management best practices  ## Configuration - Limit can be configured through the configuration service - Supports tenant-specific overrides - Changes take effect immediately for new session creation - Existing sessions are not affected by limit changes 
     * @summary Get concurrent session limit
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getConcurrentSessionLimitRaw(requestParameters: GetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Retrieves the current concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Default limit is 20 concurrent sessions per user  ## Security Benefits - Prevents session hijacking through multiple login attempts - Reduces server resource consumption - Limits potential attack surface - Enforces session management best practices  ## Configuration - Limit can be configured through the configuration service - Supports tenant-specific overrides - Changes take effect immediately for new session creation - Existing sessions are not affected by limit changes 
     * Get concurrent session limit
     */
    getConcurrentSessionLimit(requestParameters: GetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Retrieves the current tenant for the session
     * @summary Get current tenant
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getCurrentTenantRaw(requestParameters: GetCurrentTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the current tenant for the session
     * Get current tenant
     */
    getCurrentTenant(requestParameters: GetCurrentTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the currently selected tenants for multi-tenant aggregation within a session.  ## Multi-Tenant Aggregation - Users can select multiple tenants to view aggregated data - Selected tenants determine which data is visible in cross-tenant views - Default behavior shows only current tenant data - Selected tenants must be within user\'s available tenant access  ## Use Cases - **MSSP Operations**: View data across multiple customer tenants - **Parent/Child Organizations**: Aggregate data from subsidiary tenants - **Cross-Department Views**: Combine data from different organizational units - **Reporting**: Generate reports across multiple tenant datasets  ## Security Considerations - Only tenants the user has access to can be selected - Cross-tenant relationships are validated - All data access respects tenant isolation policies - Audit logs track cross-tenant data access 
     * @summary Get selected tenants
     * @param {string} sessionId Unique session identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getSelectedTenantsRaw(requestParameters: GetSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Retrieves the currently selected tenants for multi-tenant aggregation within a session.  ## Multi-Tenant Aggregation - Users can select multiple tenants to view aggregated data - Selected tenants determine which data is visible in cross-tenant views - Default behavior shows only current tenant data - Selected tenants must be within user\'s available tenant access  ## Use Cases - **MSSP Operations**: View data across multiple customer tenants - **Parent/Child Organizations**: Aggregate data from subsidiary tenants - **Cross-Department Views**: Combine data from different organizational units - **Reporting**: Generate reports across multiple tenant datasets  ## Security Considerations - Only tenants the user has access to can be selected - Cross-tenant relationships are validated - All data access respects tenant isolation policies - Audit logs track cross-tenant data access 
     * Get selected tenants
     */
    getSelectedTenants(requestParameters: GetSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Retrieves session information by session ID
     * @summary Get session details
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getSessionRaw(requestParameters: GetSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>>;

    /**
     * Retrieves session information by session ID
     * Get session details
     */
    getSession(requestParameters: GetSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse>;

    /**
     * Retrieves session statistics (admin only)
     * @summary Get session statistics
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getSessionStatsRaw(requestParameters: GetSessionStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves session statistics (admin only)
     * Get session statistics
     */
    getSessionStats(requestParameters: GetSessionStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves current session timeout configuration
     * @summary Get session timeout
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getSessionTimeoutRaw(requestParameters: GetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves current session timeout configuration
     * Get session timeout
     */
    getSessionTimeout(requestParameters: GetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all sessions for a specific tenant (admin only)
     * @summary Get sessions by tenant
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getSessionsByTenantRaw(requestParameters: GetSessionsByTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>>;

    /**
     * Retrieves all sessions for a specific tenant (admin only)
     * Get sessions by tenant
     */
    getSessionsByTenant(requestParameters: GetSessionsByTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse>;

    /**
     * Retrieves all sessions for a specific user (admin only)
     * @summary Get user sessions
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getUserSessionsRaw(requestParameters: GetUserSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>>;

    /**
     * Retrieves all sessions for a specific user (admin only)
     * Get user sessions
     */
    getUserSessions(requestParameters: GetUserSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse>;

    /**
     * Retrieves timezone preference for a user
     * @summary Get user timezone
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    getUserTimezone1Raw(requestParameters: GetUserTimezone1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves timezone preference for a user
     * Get user timezone
     */
    getUserTimezone1(requestParameters: GetUserTimezone1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Checks if user has access to a specific tenant
     * @summary Check tenant access
     * @param {string} sessionId Session ID
     * @param {string} tenantId Tenant ID to check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    hasAccessToTenantRaw(requestParameters: HasAccessToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Checks if user has access to a specific tenant
     * Check tenant access
     */
    hasAccessToTenant(requestParameters: HasAccessToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Logs specific activity for audit purposes
     * @summary Log session activity
     * @param {string} sessionId Session ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    logActivityRaw(requestParameters: LogActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Logs specific activity for audit purposes
     * Log session activity
     */
    logActivity(requestParameters: LogActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Selects which tenants\' data should be visible for multi-tenant data aggregation. Only tenants in the session\'s selectable_tenant_ids (based on current tenant\'s relationships) can be selected.
     * @summary Select tenants for multi-tenant aggregation
     * @param {string} sessionId Session ID
     * @param {UpdateTenantSelectionRequest} updateTenantSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    selectTenantsRaw(requestParameters: SelectTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>>;

    /**
     * Selects which tenants\' data should be visible for multi-tenant data aggregation. Only tenants in the session\'s selectable_tenant_ids (based on current tenant\'s relationships) can be selected.
     * Select tenants for multi-tenant aggregation
     */
    selectTenants(requestParameters: SelectTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse>;

    /**
     * Updates the concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Recommended range: 5-50 sessions per user  ## Security Considerations - Lower limits increase security but may impact user experience - Higher limits allow more flexibility but increase resource usage - Changes affect only new session creation attempts - Existing sessions are not terminated when limit is reduced  ## Validation - Limit must be a positive integer - Minimum recommended limit: 5 sessions - Maximum recommended limit: 50 sessions - Changes are audited for security compliance 
     * @summary Set concurrent session limit
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    setConcurrentSessionLimitRaw(requestParameters: SetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Updates the concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Recommended range: 5-50 sessions per user  ## Security Considerations - Lower limits increase security but may impact user experience - Higher limits allow more flexibility but increase resource usage - Changes affect only new session creation attempts - Existing sessions are not terminated when limit is reduced  ## Validation - Limit must be a positive integer - Minimum recommended limit: 5 sessions - Maximum recommended limit: 50 sessions - Changes are audited for security compliance 
     * Set concurrent session limit
     */
    setConcurrentSessionLimit(requestParameters: SetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Updates session timeout configuration
     * @summary Set session timeout
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    setSessionTimeoutRaw(requestParameters: SetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates session timeout configuration
     * Set session timeout
     */
    setSessionTimeout(requestParameters: SetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Sets timezone preference for a user
     * @summary Set user timezone
     * @param {string} sessionId Session ID
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    setUserTimezoneRaw(requestParameters: SetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sets timezone preference for a user
     * Set user timezone
     */
    setUserTimezone(requestParameters: SetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Switches the current tenant for a session
     * @summary Switch tenant
     * @param {string} sessionId Session ID
     * @param {SwitchTenantRequest} switchTenantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    switchTenantRaw(requestParameters: SwitchTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSwitchResponse>>;

    /**
     * Switches the current tenant for a session
     * Switch tenant
     */
    switchTenant(requestParameters: SwitchTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSwitchResponse>;

    /**
     * Updates session activity and extends timeout
     * @summary Update session activity
     * @param {UpdateActivityRequest} updateActivityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    updateActivityRaw(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>>;

    /**
     * Updates session activity and extends timeout
     * Update session activity
     */
    updateActivity(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse>;

    /**
     * Validates if a session is still active
     * @summary Validate session
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApiInterface
     */
    validateSessionRaw(requestParameters: ValidateSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionValidationResponse>>;

    /**
     * Validates if a session is still active
     * Validate session
     */
    validateSession(requestParameters: ValidateSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionValidationResponse>;

}

/**
 * 
 */
export class SessionsApi extends runtime.BaseAPI implements SessionsApiInterface {

    /**
     * Removes expired sessions from the system (admin only)
     * Cleanup expired sessions
     */
    async cleanupExpiredSessionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/cleanup`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Removes expired sessions from the system (admin only)
     * Cleanup expired sessions
     */
    async cleanupExpiredSessions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cleanupExpiredSessionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clears the selected tenants for multi-tenant aggregation, defaulting to current tenant only.  ## Effect - Removes all selected tenants from the session - Defaults to showing only current tenant data - All subsequent API calls will respect current tenant only - Cross-tenant aggregation is disabled  ## Use Cases - **Reset to Default**: Return to single-tenant view - **Security Cleanup**: Clear multi-tenant access after sensitive operations - **Session Reset**: Reset tenant selection to safe defaults - **Access Control**: Ensure only current tenant data is visible  ## Security Benefits - Reduces data exposure to minimum required scope - Prevents accidental cross-tenant data access - Simplifies audit trail to single tenant - Reduces complexity of permission evaluation  ## Implementation This endpoint delegates to the `select-tenants` endpoint with an empty list. 
     * Clear selected tenants
     */
    async clearSelectedTenantsRaw(requestParameters: ClearSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling clearSelectedTenants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/selected-tenants`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Clears the selected tenants for multi-tenant aggregation, defaulting to current tenant only.  ## Effect - Removes all selected tenants from the session - Defaults to showing only current tenant data - All subsequent API calls will respect current tenant only - Cross-tenant aggregation is disabled  ## Use Cases - **Reset to Default**: Return to single-tenant view - **Security Cleanup**: Clear multi-tenant access after sensitive operations - **Session Reset**: Reset tenant selection to safe defaults - **Access Control**: Ensure only current tenant data is visible  ## Security Benefits - Reduces data exposure to minimum required scope - Prevents accidental cross-tenant data access - Simplifies audit trail to single tenant - Reduces complexity of permission evaluation  ## Implementation This endpoint delegates to the `select-tenants` endpoint with an empty list. 
     * Clear selected tenants
     */
    async clearSelectedTenants(requestParameters: ClearSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.clearSelectedTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new user session with JWT token validation and comprehensive multi-tenant access control.  ## Authentication Flow 1. Validates JWT token from Authorization header 2. Extracts user information from JWT claims 3. Determines user\'s tenant access based on domain mapping 4. Creates or retrieves user record in the system 5. Establishes session with current tenant context 6. Loads comprehensive permissions for current and cross-tenant access  ## Multi-Tenant Context - Users can belong to multiple tenants simultaneously - Session establishes a \'current tenant\' for API operations - Cross-tenant relationships enable access to other tenants - Selected tenants allow aggregation across multiple tenant datasets  ## Permission System - RBAC (Role-Based Access Control) with granular permissions - MAC (Mandatory Access Control) with security labels - Cross-tenant permissions for relationship-based access - Effective permissions combine all access levels  ## Session Lifecycle - Sessions are created with configurable timeout - Activity tracking extends session duration - Sessions can be switched between available tenants - Expired sessions are automatically cleaned up  ## Session Transport - Browser: HttpOnly cookie `aegis_session_id` is set on success (SameSite=Lax, Secure) - Integrations: prefer header `X-Session-Id: <sessionId>` - Legacy fallback: `sessionId` query parameter 
     * Create a new session
     */
    async createSessionRaw(requestParameters: CreateSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSessionRequestToJSON(requestParameters['createSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new user session with JWT token validation and comprehensive multi-tenant access control.  ## Authentication Flow 1. Validates JWT token from Authorization header 2. Extracts user information from JWT claims 3. Determines user\'s tenant access based on domain mapping 4. Creates or retrieves user record in the system 5. Establishes session with current tenant context 6. Loads comprehensive permissions for current and cross-tenant access  ## Multi-Tenant Context - Users can belong to multiple tenants simultaneously - Session establishes a \'current tenant\' for API operations - Cross-tenant relationships enable access to other tenants - Selected tenants allow aggregation across multiple tenant datasets  ## Permission System - RBAC (Role-Based Access Control) with granular permissions - MAC (Mandatory Access Control) with security labels - Cross-tenant permissions for relationship-based access - Effective permissions combine all access levels  ## Session Lifecycle - Sessions are created with configurable timeout - Activity tracking extends session duration - Sessions can be switched between available tenants - Expired sessions are automatically cleaned up  ## Session Transport - Browser: HttpOnly cookie `aegis_session_id` is set on success (SameSite=Lax, Secure) - Integrations: prefer header `X-Session-Id: <sessionId>` - Legacy fallback: `sessionId` query parameter 
     * Create a new session
     */
    async createSession(requestParameters: CreateSessionOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse> {
        const response = await this.createSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Terminates a user session
     * Destroy session
     */
    async destroySessionRaw(requestParameters: DestroySessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling destroySession().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        if (requestParameters['deletedByUserId'] != null) {
            queryParameters['deletedByUserId'] = requestParameters['deletedByUserId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Terminates a user session
     * Destroy session
     */
    async destroySession(requestParameters: DestroySessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.destroySessionRaw(requestParameters, initOverrides);
    }

    /**
     * Diagnoses user permission state for debugging and troubleshooting purposes.  ## Diagnostic Information - **User Details**: User ID, email, and profile information - **Tenant Access**: All tenants the user can access - **Role Assignments**: All roles assigned to the user - **Permission Breakdown**: Detailed permission analysis - **Cross-Tenant Relationships**: Active cross-tenant access - **Effective Permissions**: Final computed permissions  ## Use Cases - **Troubleshooting**: Debug permission-related issues - **Access Verification**: Verify user access to specific resources - **Role Analysis**: Understand role assignments and inheritance - **Cross-Tenant Debugging**: Diagnose cross-tenant access issues - **Security Auditing**: Review user permission state  ## Security Considerations - Only available to users with diagnostic permissions - Sensitive information is included in the response - Should be used only for legitimate debugging purposes - All diagnostic access is audited 
     * Diagnose user permissions
     */
    async diagnosePermissionsRaw(requestParameters: DiagnosePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling diagnosePermissions().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling diagnosePermissions().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling diagnosePermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/diagnose-permissions`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Diagnoses user permission state for debugging and troubleshooting purposes.  ## Diagnostic Information - **User Details**: User ID, email, and profile information - **Tenant Access**: All tenants the user can access - **Role Assignments**: All roles assigned to the user - **Permission Breakdown**: Detailed permission analysis - **Cross-Tenant Relationships**: Active cross-tenant access - **Effective Permissions**: Final computed permissions  ## Use Cases - **Troubleshooting**: Debug permission-related issues - **Access Verification**: Verify user access to specific resources - **Role Analysis**: Understand role assignments and inheritance - **Cross-Tenant Debugging**: Diagnose cross-tenant access issues - **Security Auditing**: Review user permission state  ## Security Considerations - Only available to users with diagnostic permissions - Sensitive information is included in the response - Should be used only for legitimate debugging purposes - All diagnostic access is audited 
     * Diagnose user permissions
     */
    async diagnosePermissions(requestParameters: DiagnosePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.diagnosePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Extends session timeout by specified duration
     * Extend session
     */
    async extendSessionRaw(requestParameters: ExtendSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling extendSession().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling extendSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/extend`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
    }

    /**
     * Extends session timeout by specified duration
     * Extend session
     */
    async extendSession(requestParameters: ExtendSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse> {
        const response = await this.extendSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all active sessions (admin only)
     * Get active sessions
     */
    async getActiveSessionsRaw(requestParameters: GetActiveSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/active`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all active sessions (admin only)
     * Get active sessions
     */
    async getActiveSessions(requestParameters: GetActiveSessionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse> {
        const response = await this.getActiveSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all sessions with pagination and status filtering (admin only). Status filter options: \'active\' (not expired, not terminated, expiresAt > now), \'expiring_soon\' (expiring within 24 hours), \'expired\' (expiresAt < now OR deletedAt IS NOT NULL), or null/omitted (all sessions)
     * Get all sessions
     */
    async getAllSessionsRaw(requestParameters: GetAllSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all sessions with pagination and status filtering (admin only). Status filter options: \'active\' (not expired, not terminated, expiresAt > now), \'expiring_soon\' (expiring within 24 hours), \'expired\' (expiresAt < now OR deletedAt IS NOT NULL), or null/omitted (all sessions)
     * Get all sessions
     */
    async getAllSessions(requestParameters: GetAllSessionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse> {
        const response = await this.getAllSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves list of tenants accessible to the user
     * Get available tenants
     */
    async getAvailableTenants1Raw(requestParameters: GetAvailableTenants1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getAvailableTenants1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/available-tenants`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves list of tenants accessible to the user
     * Get available tenants
     */
    async getAvailableTenants1(requestParameters: GetAvailableTenants1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAvailableTenants1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a comprehensive list of available timezone IDs that can be used throughout the application.  ## Timezone Usage - These timezone IDs are used for user preference settings - All timestamps in API responses are in UTC - User\'s preferred timezone is used for display purposes - Timezone validation ensures only valid IANA timezone IDs are accepted  ## Supported Regions - **Americas**: US/Canada timezones, Alaska, Hawaii - **Europe**: Major European cities and regions - **Asia**: Major Asian cities and regions - **Africa**: Major African cities - **Australia/Pacific**: Australian cities and Pacific islands  ## Response Format Returns a simple list of timezone IDs that can be used with other timezone-related endpoints. 
     * Get available timezones
     */
    async getAvailableTimezonesRaw(requestParameters: GetAvailableTimezonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getAvailableTimezones().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/timezones`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieves a comprehensive list of available timezone IDs that can be used throughout the application.  ## Timezone Usage - These timezone IDs are used for user preference settings - All timestamps in API responses are in UTC - User\'s preferred timezone is used for display purposes - Timezone validation ensures only valid IANA timezone IDs are accepted  ## Supported Regions - **Americas**: US/Canada timezones, Alaska, Hawaii - **Europe**: Major European cities and regions - **Asia**: Major Asian cities and regions - **Africa**: Major African cities - **Australia/Pacific**: Australian cities and Pacific islands  ## Response Format Returns a simple list of timezone IDs that can be used with other timezone-related endpoints. 
     * Get available timezones
     */
    async getAvailableTimezones(requestParameters: GetAvailableTimezonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getAvailableTimezonesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Default limit is 20 concurrent sessions per user  ## Security Benefits - Prevents session hijacking through multiple login attempts - Reduces server resource consumption - Limits potential attack surface - Enforces session management best practices  ## Configuration - Limit can be configured through the configuration service - Supports tenant-specific overrides - Changes take effect immediately for new session creation - Existing sessions are not affected by limit changes 
     * Get concurrent session limit
     */
    async getConcurrentSessionLimitRaw(requestParameters: GetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/concurrent-limit`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieves the current concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Default limit is 20 concurrent sessions per user  ## Security Benefits - Prevents session hijacking through multiple login attempts - Reduces server resource consumption - Limits potential attack surface - Enforces session management best practices  ## Configuration - Limit can be configured through the configuration service - Supports tenant-specific overrides - Changes take effect immediately for new session creation - Existing sessions are not affected by limit changes 
     * Get concurrent session limit
     */
    async getConcurrentSessionLimit(requestParameters: GetConcurrentSessionLimitRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getConcurrentSessionLimitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current tenant for the session
     * Get current tenant
     */
    async getCurrentTenantRaw(requestParameters: GetCurrentTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getCurrentTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/current-tenant`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the current tenant for the session
     * Get current tenant
     */
    async getCurrentTenant(requestParameters: GetCurrentTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCurrentTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the currently selected tenants for multi-tenant aggregation within a session.  ## Multi-Tenant Aggregation - Users can select multiple tenants to view aggregated data - Selected tenants determine which data is visible in cross-tenant views - Default behavior shows only current tenant data - Selected tenants must be within user\'s available tenant access  ## Use Cases - **MSSP Operations**: View data across multiple customer tenants - **Parent/Child Organizations**: Aggregate data from subsidiary tenants - **Cross-Department Views**: Combine data from different organizational units - **Reporting**: Generate reports across multiple tenant datasets  ## Security Considerations - Only tenants the user has access to can be selected - Cross-tenant relationships are validated - All data access respects tenant isolation policies - Audit logs track cross-tenant data access 
     * Get selected tenants
     */
    async getSelectedTenantsRaw(requestParameters: GetSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getSelectedTenants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/selected-tenants`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieves the currently selected tenants for multi-tenant aggregation within a session.  ## Multi-Tenant Aggregation - Users can select multiple tenants to view aggregated data - Selected tenants determine which data is visible in cross-tenant views - Default behavior shows only current tenant data - Selected tenants must be within user\'s available tenant access  ## Use Cases - **MSSP Operations**: View data across multiple customer tenants - **Parent/Child Organizations**: Aggregate data from subsidiary tenants - **Cross-Department Views**: Combine data from different organizational units - **Reporting**: Generate reports across multiple tenant datasets  ## Security Considerations - Only tenants the user has access to can be selected - Cross-tenant relationships are validated - All data access respects tenant isolation policies - Audit logs track cross-tenant data access 
     * Get selected tenants
     */
    async getSelectedTenants(requestParameters: GetSelectedTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getSelectedTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves session information by session ID
     * Get session details
     */
    async getSessionRaw(requestParameters: GetSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves session information by session ID
     * Get session details
     */
    async getSession(requestParameters: GetSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse> {
        const response = await this.getSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves session statistics (admin only)
     * Get session statistics
     */
    async getSessionStatsRaw(requestParameters: GetSessionStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves session statistics (admin only)
     * Get session statistics
     */
    async getSessionStats(requestParameters: GetSessionStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSessionStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves current session timeout configuration
     * Get session timeout
     */
    async getSessionTimeoutRaw(requestParameters: GetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/timeout`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves current session timeout configuration
     * Get session timeout
     */
    async getSessionTimeout(requestParameters: GetSessionTimeoutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSessionTimeoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all sessions for a specific tenant (admin only)
     * Get sessions by tenant
     */
    async getSessionsByTenantRaw(requestParameters: GetSessionsByTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getSessionsByTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all sessions for a specific tenant (admin only)
     * Get sessions by tenant
     */
    async getSessionsByTenant(requestParameters: GetSessionsByTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse> {
        const response = await this.getSessionsByTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all sessions for a specific user (admin only)
     * Get user sessions
     */
    async getUserSessionsRaw(requestParameters: GetUserSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserSessions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all sessions for a specific user (admin only)
     * Get user sessions
     */
    async getUserSessions(requestParameters: GetUserSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionListResponse> {
        const response = await this.getUserSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves timezone preference for a user
     * Get user timezone
     */
    async getUserTimezone1Raw(requestParameters: GetUserTimezone1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getUserTimezone1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/timezone`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves timezone preference for a user
     * Get user timezone
     */
    async getUserTimezone1(requestParameters: GetUserTimezone1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUserTimezone1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if user has access to a specific tenant
     * Check tenant access
     */
    async hasAccessToTenantRaw(requestParameters: HasAccessToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling hasAccessToTenant().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling hasAccessToTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/has-access/{tenantId}`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Checks if user has access to a specific tenant
     * Check tenant access
     */
    async hasAccessToTenant(requestParameters: HasAccessToTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.hasAccessToTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Logs specific activity for audit purposes
     * Log session activity
     */
    async logActivityRaw(requestParameters: LogActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling logActivity().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling logActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/log-activity`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logs specific activity for audit purposes
     * Log session activity
     */
    async logActivity(requestParameters: LogActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logActivityRaw(requestParameters, initOverrides);
    }

    /**
     * Selects which tenants\' data should be visible for multi-tenant data aggregation. Only tenants in the session\'s selectable_tenant_ids (based on current tenant\'s relationships) can be selected.
     * Select tenants for multi-tenant aggregation
     */
    async selectTenantsRaw(requestParameters: SelectTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling selectTenants().'
            );
        }

        if (requestParameters['updateTenantSelectionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTenantSelectionRequest',
                'Required parameter "updateTenantSelectionRequest" was null or undefined when calling selectTenants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/select-tenants`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTenantSelectionRequestToJSON(requestParameters['updateTenantSelectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
    }

    /**
     * Selects which tenants\' data should be visible for multi-tenant data aggregation. Only tenants in the session\'s selectable_tenant_ids (based on current tenant\'s relationships) can be selected.
     * Select tenants for multi-tenant aggregation
     */
    async selectTenants(requestParameters: SelectTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse> {
        const response = await this.selectTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Recommended range: 5-50 sessions per user  ## Security Considerations - Lower limits increase security but may impact user experience - Higher limits allow more flexibility but increase resource usage - Changes affect only new session creation attempts - Existing sessions are not terminated when limit is reduced  ## Validation - Limit must be a positive integer - Minimum recommended limit: 5 sessions - Maximum recommended limit: 50 sessions - Changes are audited for security compliance 
     * Set concurrent session limit
     */
    async setConcurrentSessionLimitRaw(requestParameters: SetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setConcurrentSessionLimit().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/concurrent-limit`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates the concurrent session limit configuration.  ## Concurrent Session Limit - Controls the maximum number of active sessions a user can have simultaneously - Helps prevent session abuse and resource exhaustion - Configurable per tenant or system-wide - Recommended range: 5-50 sessions per user  ## Security Considerations - Lower limits increase security but may impact user experience - Higher limits allow more flexibility but increase resource usage - Changes affect only new session creation attempts - Existing sessions are not terminated when limit is reduced  ## Validation - Limit must be a positive integer - Minimum recommended limit: 5 sessions - Maximum recommended limit: 50 sessions - Changes are audited for security compliance 
     * Set concurrent session limit
     */
    async setConcurrentSessionLimit(requestParameters: SetConcurrentSessionLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setConcurrentSessionLimitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates session timeout configuration
     * Set session timeout
     */
    async setSessionTimeoutRaw(requestParameters: SetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setSessionTimeout().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/timeout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates session timeout configuration
     * Set session timeout
     */
    async setSessionTimeout(requestParameters: SetSessionTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setSessionTimeoutRaw(requestParameters, initOverrides);
    }

    /**
     * Sets timezone preference for a user
     * Set user timezone
     */
    async setUserTimezoneRaw(requestParameters: SetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling setUserTimezone().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setUserTimezone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/set-timezone`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sets timezone preference for a user
     * Set user timezone
     */
    async setUserTimezone(requestParameters: SetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setUserTimezoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Switches the current tenant for a session
     * Switch tenant
     */
    async switchTenantRaw(requestParameters: SwitchTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSwitchResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling switchTenant().'
            );
        }

        if (requestParameters['switchTenantRequest'] == null) {
            throw new runtime.RequiredError(
                'switchTenantRequest',
                'Required parameter "switchTenantRequest" was null or undefined when calling switchTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/switch-tenant`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SwitchTenantRequestToJSON(requestParameters['switchTenantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSwitchResponseFromJSON(jsonValue));
    }

    /**
     * Switches the current tenant for a session
     * Switch tenant
     */
    async switchTenant(requestParameters: SwitchTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSwitchResponse> {
        const response = await this.switchTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates session activity and extends timeout
     * Update session activity
     */
    async updateActivityRaw(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionResponse>> {
        if (requestParameters['updateActivityRequest'] == null) {
            throw new runtime.RequiredError(
                'updateActivityRequest',
                'Required parameter "updateActivityRequest" was null or undefined when calling updateActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/update-activity`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateActivityRequestToJSON(requestParameters['updateActivityRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue));
    }

    /**
     * Updates session activity and extends timeout
     * Update session activity
     */
    async updateActivity(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionResponse> {
        const response = await this.updateActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates if a session is still active
     * Validate session
     */
    async validateSessionRaw(requestParameters: ValidateSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionValidationResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling validateSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/sessions/{sessionId}/validate`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionValidationResponseFromJSON(jsonValue));
    }

    /**
     * Validates if a session is still active
     * Validate session
     */
    async validateSession(requestParameters: ValidateSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionValidationResponse> {
        const response = await this.validateSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
